export default function formatDate(date: Date): string {
  let day: number | string = date.getDate();
  let month: number | string = date.getMonth() + 1; // Months are zero-based
  const year: number = date.getFullYear();

  // Add leading zeros if needed
  if (day < 10) {
    day = "0" + day;
  }
  if (month < 10) {
    month = "0" + month;
  }

  return `${day}/${month}/${year}`;
}
